// 1. 외부 패키지
import { useRecoilValue } from "recoil"

// 2. 프로젝트 내부 alias


// 3. 상대 경로
import get_basic_detail_selector from "../../selector/get-basic-detail-selector"
import { getQuery } from "../../shared/function"
import media_atom from "../../atom/media-atom"

// 4. 타입


const Bottom = () => {

	const media = useRecoilValue(media_atom);

	const data = useRecoilValue(get_basic_detail_selector(getQuery().idx));

	const { detail } = data;

	return (
		<div className='bottom'>
			{(media === 'P' || media === 'T') &&
				<div className='item_info'>
					<span>
						분양정보번호 : <strong className='fw500'>{detail.code || "No CODE"}</strong>
					</span>
					<span>
						등록일자 : <strong className='fw500'>{detail.regist_ymd}</strong>
					</span>
				</div>
			}
		</div>
	);
};

export default Bottom;